import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "@/App.css";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Services from "@/components/Services";
import HowItWorks from "@/components/HowItWorks";
import Packages from "@/components/Packages";
import About from "@/components/About";
import Pricing from "@/components/Pricing";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import Success from "@/components/Success";
import { Toaster } from "@/components/ui/sonner";

// Home page component with all sections
const HomePage = () => (
  <>
    <Navbar />
    <Hero />
    <Services />
    <HowItWorks />
    <Packages />
    <About />
    <Pricing />
    <Contact />
    <Footer />
  </>
);

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/success" element={<Success />} />
        </Routes>
        <Toaster />
      </div>
    </Router>
  );
}

export default App;
